"use client";

import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import { useMyTripForBookingId } from "@myaccount/_client/hooks";
import styles from "./AccountPushToAppPage.module.scss";
import { getPushToAppCardCopy } from "@myaccount/_components/account-push-to-app/get-push-to-app-copy";
import { useValidSlug } from "@myaccount/_components/account-push-to-app";

type AccountPushToAppPageTitleProps = {
    bookingId: string;
    headingId: string;
    slug: string;
};

export const AccountPushToAppPageTitle: React.FC<
    AccountPushToAppPageTitleProps
> = ({ bookingId, headingId, slug }) => {
    const [validatedSlug, text] = useValidSlug(slug) ?? [];
    const mvpCopyDict = useI18n("account").account.mvpPages.pages;
    const trip = useMyTripForBookingId(bookingId);

    if (!validatedSlug || !text || !trip?.departure?.tourCode) {
        return null;
    }

    const baseL10n = mvpCopyDict[validatedSlug] ?? null;
    const cardCopy = getPushToAppCardCopy(slug, trip, baseL10n);

    return (
        <Text.Heading
            id={headingId}
            order="2"
            tag="h1"
            className={styles["account-page-title"]}
        >
            {cardCopy?.pageTitle ?? text}
        </Text.Heading>
    );
};
